import { Pagination, Users } from 'src/app/shared/models';

export interface UserState {
  list: Users[];
  details: Users | null;
}

export const initialState: UserState = {
  list: [],
  details: null,
};
